import basicGroup from "./basic";
import layoutGroup from "./layout";
import mediaGroup from "./media";
import embedsGroup from "./embeds";
import formGroup from "./form";
import socialGroup from "./social";
import codeGroup from "./code";
import savedGroup from "./saved";

export default [
    basicGroup,
    formGroup,
    layoutGroup,
    mediaGroup,
    embedsGroup,
    socialGroup,
    codeGroup,
    savedGroup
];
